import { motion } from "framer-motion";
import React from "react";

const OrderDetails = () => {
  const trackingSteps = [
    { name: "Order Confirmed, Feb 01", completed: true },
    { name: "Shipped", completed: true, details: "Your item has arrived at a facility, Pune, Mon 3rd Feb" },
    { name: "Out For Delivery", completed: false },
    { name: "Delivery, Tomorrow, Feb 04 By 11 PM", completed: false },
  ];

  return (
    <div className="max-w-lg mx-auto p-6 bg-white shadow-lg rounded-lg mt-20">
      <h2 className="text-2xl font-bold mb-4">Order Tracking</h2>
      <div className="relative">
        {trackingSteps.map((step, index) => (
          <div key={index} className="flex items-start relative">
            {/* Progress Line */}
            {index !== trackingSteps.length - 1 && (
              <motion.div
                initial={{ height: 0 }}
                animate={{ height: step.completed ? "100%" : "50%" }}
                transition={{ duration: 0.5, ease: "easeInOut" }}
                className={`absolute left-[11px] top-6 ${
                  step.completed ? "bg-gradient-to-b from-cyan-400  to-green-500 w-[2.5px]" : "border-r-[2.5px] border-dashed border-gray-300"
                } ${index === trackingSteps.length - 2 ? "h-8" : "h-full"}`} // Ensures last line is shorter
              ></motion.div>
            )}

            {/* Step Indicator */}
            <div className="relative flex-shrink-0">
            <div
  className={`flex items-center justify-center rounded-full ${
    step.completed
      ? "w-6 h-6 bg-gradient-to-r from-cyan-400 via-teal-500 to-green-500" // Gradient for completed steps
      : !step.completed && index > 0 && trackingSteps[index - 1].completed
      ? "w-2 h-2 bg-green-500 ml-2" // Small gray circle for specific condition
      : "w-6 h-6 border-gray-300 border-[1.5px]" // Default gray circle for incomplete steps
  } relative`}
>
                {step.completed ? (
                  <svg
                    className="w-4 h-4 text-white"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
                  </svg>
                ) : (
                  <span className={!step.completed && index > 0 && trackingSteps[index - 1].completed ? 'hidden' : "flex text-white"}>•</span>
                )}
              </div>

              {/* Blinking Gradient Effect */}
              {!step.completed && index > 0 && trackingSteps[index - 1].completed && (
                <motion.div
                  animate={{ scale: [1, 2.4, 1], opacity: [0.6, 0.2, 0.6] }}
                  transition={{ repeat: Infinity, duration: 1.2, ease: "easeInOut" }}
                  className="absolute -top-[2px] left-[6px] w-3 h-3 bg-gradient-to-r from-teal-500  to-green-500 opacity-20 rounded-full"
                ></motion.div>
              )}
            </div>

            {/* Step Description */}
            <div className="pb-4 ml-4"> {/* Padding-bottom ensures last step has no extra space */}
              <p className={`text-sm font-medium ${step.completed ? "text-black" : "text-gray-500"}`}>
                {step.name}
              </p>
              {step.details && <p className="text-xs text-gray-500">{step.details}</p>}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default OrderDetails;
